
import React from 'react';
import { HashRouter } from 'react-router-dom';

import GlobalStyles from './styles/global';
import Routes from './routes';

const App: React.FC = () => (
  <>
    <HashRouter>
      <Routes />
    </HashRouter>
    <GlobalStyles/>
  </>
);

export default App;